import { render, staticRenderFns } from "./BaseMitMyBorrowedList.vue?vue&type=template&id=52c8082a&scoped=true"
import script from "./BaseMitMyBorrowedList.vue?vue&type=script&lang=js"
export * from "./BaseMitMyBorrowedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c8082a",
  null
  
)

export default component.exports